// src/pages/Setor2Page.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Setor2Page() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: 4 }}>
      <Typography variant="h4" gutterBottom color="text.primary">
        Setor 5: TI
      </Typography>
      <Typography color="text.secondary">
        Conteúdo do setor TI vai aqui.
      </Typography>
    </Box>
  );
}
